import React from "react";
import event1 from "../static/img/synergy.png";
import event2 from '../static/img/bty0kj9l.png';
import event1svg from "../static/img/event1.svg";
import arrow from "../static/img/down_arrow.svg";
import Resilienceimagesvg from "../static/img/Resilience Web page (2).jpg";
import "../static/css/Event1dis.css";

const Event1dis = ({ scrollToEventReg }) => {
  const handleBrochureDownload = () => {
    const pdfUrl = `${process.env.PUBLIC_URL}/files/The Resilience Summit Agenda.pdf`;

    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "The Resilience Summit Agenda.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.open(pdfUrl, "_blank");
  };

  return (
    <>
      <div className="synergy">
        <div className="synergy-container">
          <div className="synergy-content-1">
            <div className="synergy-img">
              <img src={event2} alt="Synergy Summit" />
            </div>
            <div className="synergy-content-text">
              <div className="synergy-title">
                <p>Resilience Summit</p>
              </div>
              <div className="synergy-caption">
                <p>
                  Building Resilient Supply Chains & Systems: Strategies to implement from procurement to delivery
                </p>
                <span>By Quindl</span>
              </div>
            </div>
          </div>
          <div className="synergy-content-2">
            <div className="synergy-discription">
              <p>
                Step into a world of resilience and opportunity at <span style={{ fontWeight: 'bold' }}>The Resilience Summit 2024</span> —a dynamic virtual event where supply chain leaders, innovators, and strategists come together to build a stronger, more adaptable future. This is more than just an event; it’s your gateway to fortifying every stage of your supply chain. Connect with experts, gain transformative insights, and explore strategies that make your operations agile, resilient, and future-ready. At <span style={{ fontWeight: 'bold' }}>The Resilience Summit </span>, you’ll not only expand your network but also equip your organization to thrive amid uncertainty. Let <span style={{ fontWeight: 'bold' }}>Quindl's</span> platform be the catalyst that strengthens your supply chain from end to end. The future of resilience starts here—are you ready to secure it?
              </p>
            </div>
            <div className="synergy-discription-2">
              <div className="synergy-date-book">
                <div className="synergy-date">
                  <p>Date & Time</p>
                  <span>Fri, 29 Nov 2024, 7:00 PM IST</span>
                </div>
                <div className="synergy-location-book">
                  <div className="synergy-location">
                    <p>Location</p>
                    <span>Virtual Event - Zoom</span>
                  </div>
                  <div className="synergy-book">
                    <button onClick={scrollToEventReg}>Book Tickets</button>
                  </div>
                </div>
              </div>
              <div className="event1-content4">
                <div className="event1-play">
                  <p></p>
                </div>
                <div className="event1-play-content">
                  Get to know about Virtual Event
                </div>
                <div className="event1-play-button">
                  <button onClick={handleBrochureDownload}>
                    <img src={arrow} alt="Down Arrow" />
                    Download Event Agenda 
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="event1-svg">
          <img src={Resilienceimagesvg} alt="Event SVG" />
        </div>
      </div>
    </>
  );
};

export default Event1dis;
